var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-angle-small-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9132 4.90761C11.8261 4.82049 11.7228 4.75138 11.609 4.70423C11.4952 4.65708 11.3732 4.63281 11.2501 4.63281C11.1269 4.63281 11.005 4.65708 10.8912 4.70423C10.7774 4.75138 10.674 4.82049 10.587 4.90761L7.7207 7.77324C7.6621 7.83182 7.58263 7.86473 7.49977 7.86473C7.4169 7.86473 7.33743 7.83182 7.27883 7.77324L4.4132 4.90761C4.23742 4.73174 3.99896 4.6329 3.7503 4.63285C3.50164 4.63279 3.26314 4.73151 3.08727 4.9073C2.9114 5.08309 2.81256 5.32154 2.8125 5.5702C2.81244 5.81887 2.91117 6.05737 3.08695 6.23324L5.9532 9.09949C6.15633 9.30264 6.39749 9.46379 6.66291 9.57374C6.92832 9.68368 7.21279 9.74027 7.50008 9.74027C7.78736 9.74027 8.07184 9.68368 8.33725 9.57374C8.60266 9.46379 8.84382 9.30264 9.04695 9.09949L11.9132 6.23324C12.089 6.05743 12.1877 5.81902 12.1877 5.57042C12.1877 5.32183 12.089 5.08342 11.9132 4.90761Z",
    fill: "#67686D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4686885f52f83ca993244055d1163ed9.svg";
export { ForwardRef as ReactComponent };